/** @jsx jsx */
import { memo } from 'react';
import { css, jsx } from '@emotion/core';
import Button from '@atlaskit/button/standard-button';
import { N500 } from '@atlaskit/theme/colors';
import { gridSize } from '@atlaskit/theme/constants';
import { token } from '@atlaskit/tokens';
var actionsSeparatorWidth = gridSize() * 2;
var actionStyles = css({
  display: 'flex',
  margin: 0,
  alignItems: 'center',
  // eslint-disable-next-line @repo/internal/styles/no-nested-styles
  '& + &::before': {
    display: 'inline-block',
    width: "".concat(actionsSeparatorWidth, "px"),
    color: "".concat(token('color.text.mediumEmphasis', N500)),
    content: '"·"',
    textAlign: 'center',
    verticalAlign: 'middle'
  }
});
var SectionMessageAction = /*#__PURE__*/memo(function SectionMessageAction(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      href = _ref.href,
      testId = _ref.testId,
      linkComponent = _ref.linkComponent;
  return jsx("li", {
    css: actionStyles,
    "data-testid": testId
  }, onClick || href ? jsx(Button, {
    appearance: "link",
    spacing: "none",
    onClick: onClick,
    href: href,
    component: href ? linkComponent : undefined
  }, children) : children);
});
SectionMessageAction.displayName = 'SectionMessageAction';
export default SectionMessageAction;